<template>
  <div>
    <div class="banner withoutImg">
      <div class="container">
        <div class="caption">
          <h1>
            <font style="vertical-align: inherit;">
              <font style="vertical-align: inherit;">我的帐户</font>
            </font>
          </h1>
          <p>
            <font style="vertical-align: inherit;">
              <font style="vertical-align: inherit;">您可以在下面管理和更新您的详细信息。</font>
            </font>
          </p>
        </div>
      </div>
    </div>

    <!-- Main content area start here -->
    <section class="innerPage myaccount">
      <div class="container">
        <div class="breadcrumbWrap">
          <div class="breadcrumb">
            <!-- Breadcrumb NavXT 6.2.0 -->
            <span property="itemListElement" typeof="ListItem">
              <a
                property="item"
                typeof="WebPage"
                title="Go to Jasper Morris Inside Burgundy."
                href="#/"
                class="home"
              >
                <span property="name">首页</span>
              </a>
              <meta property="position" content="1">
            </span> /
            <span property="itemListElement" typeof="ListItem">
              <span property="name">我的书签</span>
              <meta property="position" content="2">
            </span>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="ziliao" style="width:67%;float:left;margin-top: 2px;">
          <h4 style="font-size:40px;">我的书签</h4>
          <p style="border-bottom:2px solid #cccccc;line-height: 60px;">您可以在此查看此前添加到书签的文章</p>
           <div class="leftCol">
          <ul class="newsListing r1234" style="width:800px">
            <li v-for="item in info.data">
              <div
                class="post-28874 post type-post status-publish format-standard has-post-thumbnail hentry category-just-jasper category-inside-burgundy"
              >
                <h4>
                  <a :href="'#/latestinformation?id='+item.relatedId">{{item.title}}</a>
                  <span>{{item.createTime}}</span>
                </h4>

                <div class="entry">
                  <p>{{item.introduction}}</p>
                </div>

                <div class="readmore">
                  <a :href="seturl(item)">阅读更多</a>
                </div>
              </div>
            </li>
          </ul>
       
         </div>
        

        </div>
        <div class="rightCol">
          <div class="myAccountmenu">
            <h4>
              <font style="vertical-align: inherit;">
                <font style="vertical-align: inherit;">我的帐户</font>
              </font>
              <span></span>
            </h4>
            <ul id="menu-my-account" class>
              <li
                id="menu-item-332"
                class="menu-item menu-item-type-post_type menu-item-object-page menu-item-350"
              >
                <a href="#/Myprofile">
                  <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">我的资料</font>
                  </font>
                </a>
              </li>
              <li
                id="menu-item-333"
                class="menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-305 current_page_item menu-item-332"
              >
                <a href="#/Mybookmarks">
                  <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">我的书签</font>
                  </font>
                </a>
              </li>
              <li
                id="menu-item-350"
                class="menu-item menu-item-type-post_type menu-item-object-page menu-item-350"
              >
                <a href="#/Myvisit">
                  <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">我的浏览历史</font>
                  </font>
                </a>
              </li>
              <li
                id="menu-item-974"
                class="menu-item menu-item-type-post_type menu-item-object-page menu-item-974"
              >
                <a href="#/Subscribe">
                  <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">管理订阅</font>
                  </font>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import ajax from "../ajax";
export default {
  data() {
    return {
      info:[],
      contentlist:[],
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      ajax.getUserInfa(
      this.$store.state.userdata.userId
        ).then(res => {
          this.contentlist = res.data
        if (res.success) {
          console.log(res.data);
          this.info = res.data
        }
      });
    },
    seturl(data){
      let url = ''
      switch(data.relatedType){
        case '品鉴报告':url='#/Qualification';break;
        case '酒评':url='#/Tastingnotes';break;
        case '资讯':url='#/latestinformation';break;  
      }
  return url + '?id='+data.relatedId
  // +'&bookmarks=true'
    }
  }
};
</script>
  


// WEBPACK FOOTER //
// src/components/Mybookmarks.vue